var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorInternalServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 239,
    viewBox: "0 0 490 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.611 192.699C167.043 192.699 215.222 186.162 215.222 178.097C215.222 170.033 167.043 163.496 107.611 163.496C48.179 163.496 0 170.033 0 178.097C0 186.162 48.179 192.699 107.611 192.699Z",
    fill: "#E9ECEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M107.611 190.357C157.508 190.357 197.958 184.868 197.958 178.098C197.958 171.327 157.508 165.839 107.611 165.839C57.7135 165.839 17.2637 171.327 17.2637 178.098C17.2637 184.868 57.7135 190.357 107.611 190.357Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.929 233.483C306.72 246.684 406.275 216.264 417.209 181.827",
    stroke: "#002C3F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.487 83.1077C171.487 83.1077 246.297 62.4454 250.901 129.024C255.504 195.603 189.326 214.543 241.118 227.744",
    stroke: "#002C3F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M469.258 4.08734C470.221 4.08734 471.002 3.30877 471.002 2.34836C471.002 1.38794 470.221 0.609375 469.258 0.609375C468.295 0.609375 467.515 1.38794 467.515 2.34836C467.515 3.30877 468.295 4.08734 469.258 4.08734Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.516 25.7129H55.8202V164.61H175.516V25.7129Z",
    fill: "#B2B2B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.599 11.9375H43.7343V61.2975H187.599V11.9375Z",
    fill: "#74D1EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.599 70.4814H43.7343V119.841H187.599V70.4814Z",
    fill: "#74D1EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.599 129.024H43.7343V178.384H187.599V129.024Z",
    fill: "#74D1EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.826 20.5469H149.619V29.7301H158.826V20.5469Z",
    fill: "#6C63FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M172.062 20.5469H162.855V29.7301H172.062V20.5469Z",
    fill: "#6C63FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.298 20.5469H176.091V29.7301H185.298V20.5469Z",
    fill: "#6C63FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.826 78.5156H149.619V87.6989H158.826V78.5156Z",
    fill: "#6C63FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M172.062 78.5156H162.855V87.6989H172.062V78.5156Z",
    fill: "#6C63FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.298 78.5156H176.091V87.6989H185.298V78.5156Z",
    fill: "#6C63FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.826 136.485H149.619V145.669H158.826V136.485Z",
    fill: "#6C63FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M172.062 136.485H162.855V145.669H172.062V136.485Z",
    fill: "#6C63FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.298 136.485H176.091V145.669H185.298V136.485Z",
    fill: "#6C63FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M381.747 190.73C441.179 190.73 489.358 184.193 489.358 176.129C489.358 168.065 441.179 161.527 381.747 161.527C322.316 161.527 274.136 168.065 274.136 176.129C274.136 184.193 322.316 190.73 381.747 190.73Z",
    fill: "#E9ECEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M381.747 188.387C431.645 188.387 472.094 182.898 472.094 176.128C472.094 169.358 431.645 163.869 381.747 163.869C331.85 163.869 291.4 169.358 291.4 176.128C291.4 182.898 331.85 188.387 381.747 188.387Z",
    fill: "black",
    fillOpacity: 0.62
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M449.833 68.5342H330.21V163.236H449.833V68.5342Z",
    fill: "#B2B2B3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M461.736 68.5117H317.871V117.872H461.736V68.5117Z",
    fill: "#74D1EA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M461.736 127.055H317.871V176.415H461.736V127.055Z",
    fill: "#74D1EA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M432.963 76.5469H423.755V85.7301H432.963V76.5469Z",
    fill: "#6C63FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M446.199 76.5469H436.991V85.7301H446.199V76.5469Z",
    fill: "#6C63FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M459.434 76.5469H450.227V85.7301H459.434V76.5469Z",
    fill: "#6C63FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M432.963 134.517H423.755V143.7H432.963V134.517Z",
    fill: "#6C63FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M446.199 134.517H436.991V143.7H446.199V134.517Z",
    fill: "#6C63FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M459.434 134.517H450.227V143.7H459.434V134.517Z",
    fill: "#6C63FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInternalServer);
export default __webpack_public_path__ + "static/media/Error_InternalServer.8d4fbe67ec10fb0ee00d9a9909cac2b0.svg";
export { ForwardRef as ReactComponent };